<p class="mb-2 mt-2 text-bold text-gray-30" [textContent]="subcategory.title"></p>
<hr class="divider-horizontal mt-2 mb-2">
<ol class="pl-2 mb-row">
    @for (step of sanitizedSteps; track step.id) {
        <li class="mb-20" [innerHTML]="step.text_content"></li>
    }
</ol>
<hr class="divider-horizontal mt-2 mb-2">
@if (subcategory.knowledge_base_link_text && subcategory.knowledge_base_link_url) {
<p>
    <a class="text-blue text-underline-hover" [href]="subcategory.knowledge_base_link_url" target="_blank"
        [textContent]="subcategory.knowledge_base_link_text"></a>
</p>
}
